module.exports = __webpack_public_path__ + "img/clients3-717.60a1723.png";